import { DropzoneState, useDropzone } from 'react-dropzone';
import { useScopedAppFlagStore } from '@frontend/scope';

type useThreadDropzoneProps = {
  addMedia: (files: File[]) => Promise<{
    newMediaIds: string[];
  }>;
};

export const useThreadDropzone = ({ addMedia }: useThreadDropzoneProps): DropzoneState => {
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  const mmsEnhancementsEnabled = !!getFeatureFlagValue('nwx:inbox-mms-enhancements');

  const dropzoneState = useDropzone({
    accept: {
      'image/jpg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
      ...(mmsEnhancementsEnabled && {
        'application/pdf': ['.pdf'],
        'video/mp4': ['.mp4'],
      }),
    },
    onDrop: (files: File[]) => {
      addMedia(files);
    },
    noDragEventsBubbling: true,
    noClick: true,
  });

  return { ...dropzoneState };
};
